const widgetName = 'socialNetworkWidget';
let initialized = false;

function initialize() {
  $(`#${widgetName}`).append('<div class="socialTabContainer"></div>');

  $(`#${widgetName}`).on('click', '.socialNetworkTab', function () {
    const tab = $(this).attr('data-social-network-tab');
    $('.socialNetworkTab').removeClass('activeTab');
    $('.socialFeedContainer').hide();
    $(this).addClass('activeTab');
    $(`#${tab}Container`).show();
  });

  initialized = true;
}

function isCurrent(current, widget) {
  if (current) {
    $(`#${widgetName} #${widget}Tab`).addClass('activeTab');
    $(`#${widgetName} #${widget}Container`).show();
  }
}

// FACEBOOK -----------

function facebookfeed(current) {
  const fbPageURL = 'https://www.facebook.com/accessoShoWareCenter';
  const fbHeight = 555;
  const fbWidth = 446;

  const facebookfeedTab = `
    <a id="facebookfeedTab" class="socialNetworkTab" data-social-network-tab="facebookfeed">
    
    </a>
  `;
  const facebookfeedContainer = `
    <div id="facebookfeedContainer" class="socialFeedContainer" style="display: none;">
      <div class="fb-page" data-href="${fbPageURL}" data-width="${fbWidth}" data-adapt-container-width="true" data-height="${fbHeight}" data-small-header="true" data-hide-cover="false" data-show-facepile="false" data-show-posts="true">
        <div class="fb-xfbml-parse-ignore">
          <blockquote cite="${fbPageURL}"><a href="${fbPageURL}">Loading...</a></blockquote>
        </div>
      </div>
    </div>
  `;

  if (!initialized) {
    initialize();
  }

  $(`#${widgetName} .socialTabContainer`).append(facebookfeedTab);
  $(`#${widgetName}`).append(facebookfeedContainer);

  isCurrent(current, 'facebookfeed');
}

function instafeed(current) {
  const instafeedTab = `
    <a id="instafeedTab" class="socialNetworkTab" data-social-network-tab="instafeed" style="display: block;">      
    </a>
      <a href="https://twitter.com/ShoWareCenter" target="_blank" id="twitter" class="socialNetworkTab"  aria-label="showcare"  data-social-network-tab="facebookfeed">    
    </a>
  `;
  const instafeedContainer =
    '<div id="instafeedContainer" class="socialFeedContainer" style="display: none;"></div>';

  if (!initialized) {
    initialize();
  }

  $(`#${widgetName} .socialTabContainer`).append(instafeedTab);
  $(`#${widgetName}`).append(instafeedContainer);

  const feed = new Instafeed({
    target: 'instafeedContainer',
  });
  feed.run();

  isCurrent(current, 'instafeed');
}

export { facebookfeed, instafeed };
